export default __webpack_public_path__ + "static/service_walkthrough-85a2034b1e7d47358cac0833e0164a1a.webp";